'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'coin-front';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e3fc';
var svgPathData = ['M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zm448 0a192 192 0 1 1 -384 0 192 192 0 1 1 384 0zm-336 0a144 144 0 1 0 288 0 144 144 0 1 0 -288 0zm120-48c0-13.3 10.7-24 24-24s24 10.7 24 24l0 96c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-96z', 'M256 448a192 192 0 1 0 0-384 192 192 0 1 0 0 384zm0-336a144 144 0 1 1 0 288 144 144 0 1 1 0-288z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCoinFront = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;